import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import Pagination from '../../component/Admin/Pagination';
import { FaEdit, FaPlusCircle, FaTrashAlt, FaSearch, FaSort, FaSortUp, FaSortDown, FaFileAlt, FaCalendarAlt, FaUsers } from 'react-icons/fa';
import Loading from '../../component/Loading';
import Modal from 'react-modal';
import swal from 'sweetalert';
import { adminTable, formatLokasiList } from '../../component/Admin/adminTable';
import SortBar from '../../component/Admin/SortBar';
const Users = ({ data }) => {
    const navigate = useNavigate();

    // Cookies are sent automatically with withCredentials: true
    // No need for Authorization header anymore
    const [listUsers, setListUsers] = useState([]);
    const [listDevisi, setListDevisi] = useState([]);
    const [listLokasi, setListLokasi] = useState([]);
    const [periode, setPeriode] = useState(localStorage.getItem('periode') || ''); // Mengambil periode dari localStorage
    // const [status, setStatus] = useState('all');
    // const [formulir, setFormulir] = useState('all');
    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [loading, setLoading] = useState(false);
    // const [userEmail, setUserEmail] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [selectedDevisi, setSelectedDevisi] = useState('');
    const [selectedLokasiIds, setSelectedLokasiIds] = useState([]);
    const [usernameStatus, setUsernameStatus] = useState({ checking: false, available: null, message: '' });

    // Search and Sort states
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortField, setSortField] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'
    const searchTimeoutRef = useRef(null);
    const usersRequestId = useRef(0);

    // Debounce search — jangan hit API tiap ketikan / jangan reset page di mount
    useEffect(() => {
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
            setSearchTerm((prev) => {
                if (prev === searchInput) return prev;
                setPage(1);
                return searchInput;
            });
        }, 400);
        return () => {
            if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        };
    }, [searchInput]);

    useEffect(() => {
        getListUsers();
        // eslint-disable-next-line
    }, [page, limit, searchTerm, sortField, sortDirection]);

    // Devisi & lokasi hanya untuk form — load saat modal dibuka
    useEffect(() => {
        if (!modalIsOpen) return;
        if (listDevisi.length === 0) getListDevisi();
        if (listLokasi.length === 0) getListLokasi();
        // eslint-disable-next-line
    }, [modalIsOpen]);

    // Update selectedDevisi + lokasi when modalData changes
    useEffect(() => {
        if (modalData && modalData.id_user) {
            // Handle both object and direct ID formats
            let devisiId = '';
            if (modalData.id_devisi) {
                if (typeof modalData.id_devisi === 'object' && modalData.id_devisi.id_devisi) {
                    devisiId = String(modalData.id_devisi.id_devisi);
                } else {
                    devisiId = String(modalData.id_devisi);
                }
            }
            setSelectedDevisi(devisiId);
            axios.get(`api/lokasi/user/${modalData.id_user}/ids`, { withCredentials: true })
                .then((res) => setSelectedLokasiIds((res.data || []).map(Number)))
                .catch(() => setSelectedLokasiIds([]));
        } else if (modalData === null) {
            setSelectedDevisi('');
            setSelectedLokasiIds([]);
        }
        // eslint-disable-next-line
    }, [modalData]);

    const getListUsers = () => {
        const requestId = ++usersRequestId.current;
        const searchParam = searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : '';
        const sortParam = sortField ? `&sortBy=${sortField}&sortOrder=${sortDirection.toUpperCase()}` : '';
        axios.get(`api/users?page=${page}&limit=${limit}${searchParam}${sortParam}`, {
            withCredentials: true
        })
            .then((response) => {
                if (requestId !== usersRequestId.current) return;
                setMeta(response.data.meta);
                setListUsers(response.data.items);
            })
            .catch((error) => {
                if (requestId !== usersRequestId.current) return;
                console.error('Error fetching data:', error);
            });
    };
    const getListDevisi = () => {
        axios.get('api/devisi/options', {
            withCredentials: true
        })
            .then((response) => {
                setListDevisi(response.data || []);
            })
            .catch((error) => {
                console.error('Error fetching devisi:', error);
            });
    };

    const getListLokasi = () => {
        axios.get('api/lokasi/options', { withCredentials: true })
            .then((response) => {
                setListLokasi(response.data || []);
            })
            .catch((error) => {
                console.error('Error fetching lokasi:', error);
            });
    };

    const toggleLokasi = (idLokasi) => {
        const id = Number(idLokasi);
        setSelectedLokasiIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const saveUserLokasi = async (id_user) => {
        await axios.put(
            `api/lokasi/user/${id_user}`,
            { lokasiIds: selectedLokasiIds },
            { withCredentials: true }
        );
    };


    const selectPage = (value) => {
        setPage(value);
    };

    const nextPage = () => {
        if (page < meta.totalPages) {
            setPage(page + 1);
        }
    };

    const prevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const limitPage = (event) => {
        setLimit(Number(event.target.value));
    };


    const closeModal = () => {
        setModalIsOpen(false);
        setModalData(null);
        setSelectedDevisi('');
        setSelectedLokasiIds([]);
        setUsernameStatus({ checking: false, available: null, message: '' });
    }


    const handleClick = (id) => {
        const user = listUsers.find(item => item.id_user === id);
        if (user) {
            setModalData(user);
            setModalIsOpen(true);
        } else {
            setModalData(null);
            setSelectedDevisi('');
            setModalIsOpen(false);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        // Check username availability before submit (only for create)
        if ((!modalData || !modalData.id_user) && usernameStatus.available === false) {
            swal("Gagal", "Username sudah digunakan. Silakan pilih username lain.", "error");
            return;
        }

        setLoading(true);
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());

        // Convert standard_jam_kerja to number if provided
        if (data.standard_jam_kerja) {
            data.standard_jam_kerja = parseFloat(data.standard_jam_kerja);
        } else if (data.standard_jam_kerja === '') {
            // If empty, set to default 7 for new users, or remove for updates
            if (!modalData || !modalData.id_user) {
                data.standard_jam_kerja = 7;
            } else {
                delete data.standard_jam_kerja;
            }
        }

        if (modalData && modalData.id_user) {
            // Update: Remove password if empty, remove username (cannot be changed)
            if (!data.password) {
                delete data.password;
            }
            delete data.username; // Username cannot be updated
        }

        if (modalData && modalData.id_user) {
            // Update existing data
            axios.put(`api/users/${modalData.id_user}`, data, {
                withCredentials: true
            })
                .then(async () => {
                    await saveUserLokasi(modalData.id_user);
                    swal("Berhasil", "Data pegawai berhasil diupdate!", "success");
                    getListUsers(); // Refresh the list
                    closeModal();
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error updating data:', error);
                    swal("Gagal", error.response?.data?.message || "Gagal mengupdate pegawai", "error");
                    setLoading(false);
                });
        } else {
            // Add new data
            axios.post('api/users', data, {
                withCredentials: true
            })
                .then(async (response) => {
                    const newId = response.data?.id_user;
                    if (newId) {
                        await saveUserLokasi(newId);
                    }
                    swal("Berhasil", "Pegawai berhasil ditambahkan!", "success");
                    getListUsers(); // Refresh the list
                    closeModal();
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error adding data:', error);
                    swal("Gagal", error.response?.data?.message || "Gagal menambahkan pegawai", "error");
                    setLoading(false);
                });
        }
    };

    const openAddModal = () => {
        setModalData(null); // Reset modal data for new entry
        setSelectedDevisi(''); // Reset selected devisi
        setSelectedLokasiIds([]);
        setUsernameStatus({ checking: false, available: null, message: '' }); // Reset username status
        setModalIsOpen(true); // Open modal
    };

    // Check username availability
    const checkUsernameAvailability = useCallback(async (username) => {
        if (!username || username.trim() === '') {
            setUsernameStatus({ checking: false, available: null, message: '' });
            return;
        }

        // Skip check if editing existing user
        if (modalData && modalData.id_user) {
            setUsernameStatus({ checking: false, available: null, message: '' });
            return;
        }

        setUsernameStatus({ checking: true, available: null, message: 'Memeriksa username...' });

        try {
            const response = await axios.get(`api/users/check-username/${encodeURIComponent(username)}`, {
                withCredentials: true
            });

            if (response.data.available) {
                setUsernameStatus({
                    checking: false,
                    available: true,
                    message: 'Username tersedia'
                });
            } else {
                setUsernameStatus({
                    checking: false,
                    available: false,
                    message: 'Username sudah digunakan'
                });
            }
        } catch (error) {
            console.error('Error checking username:', error);
            setUsernameStatus({
                checking: false,
                available: null,
                message: 'Gagal memeriksa username'
            });
        }
    }, [modalData]);

    // Debounce with useRef
    const timeoutRef = useRef(null);
    const debouncedCheckUsername = useCallback((username) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            checkUsernameAvailability(username);
        }, 500);
    }, [checkUsernameAvailability]);

    // Handle sort
    const handleSort = (field) => {
        if (field == null) {
            setSortField(null);
            setSortDirection('asc');
            setPage(1);
            return;
        }
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
        setPage(1);
    };

    // Data is already sorted on server-side, no need for client-side sorting

    // Get sort icon
    const getSortIcon = (field) => {
        if (sortField !== field) {
            return <FaSort className="ml-1 text-gray-400" />;
        }
        return sortDirection === 'asc'
            ? <FaSortUp className="ml-1 text-white" />
            : <FaSortDown className="ml-1 text-white" />;
    };
    return (
        <>
            {loading ? <Loading /> : null}

            <div className={adminTable.pageHeader}>
                <div>
                    <h1 className={adminTable.pageTitle}>
                        <FaUsers className="text-[#1B3C33]" /> Data Pegawai
                    </h1>
                    <p className={adminTable.pageSubtitle}>Kelola pegawai, devisi, dan lokasi absensi</p>
                </div>
                <button className={adminTable.btnPrimary} onClick={openAddModal} type="button">
                    <FaPlusCircle /> Tambah Pegawai
                </button>
            </div>

            <div className={adminTable.searchToolbar}>
                <div className={adminTable.searchWrap}>
                    <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                    <input
                        type="text"
                        placeholder="Cari username, nama, email, atau devisi..."
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        className={adminTable.searchInput}
                    />
                </div>
                <SortBar
                    options={[
                        { value: 'nama', label: 'Nama' },
                        { value: 'username', label: 'Username' },
                        { value: 'email', label: 'Email' },
                        { value: 'devisi', label: 'Devisi' },
                    ]}
                    sortField={sortField}
                    sortDirection={sortDirection}
                    onSort={handleSort}
                />
            </div>

            <div>
                {/* Mobile: kartu */}
                <div className={adminTable.list}>
                    {listUsers.length > 0 ? (
                        listUsers.map((item) => (
                            <div key={item.id_user} className={adminTable.listItem}>
                                <div className={adminTable.listTop}>
                                    <div className="min-w-0 flex-1">
                                        <div className={adminTable.listTitle}>{item.nama}</div>
                                        <div className={adminTable.listSub}>@{item.username} · {item.id_devisi?.nama_divisi || '-'}</div>
                                    </div>
                                    <div className={adminTable.listActions}>
                                        <button type="button" onClick={() => navigate(`/admin/users/detail/${item.id_user}`)} className={`${adminTable.actionBtn} text-zafu-green hover:bg-zafu-cream`} title="Detail">
                                            <FaCalendarAlt />
                                        </button>
                                        <button type="button" onClick={() => navigate(`/admin/users/report/${item.id_user}`)} className={`${adminTable.actionBtn} text-zafu-green-muted hover:bg-zafu-cream`} title="Rekap">
                                            <FaFileAlt />
                                        </button>
                                        <button type="button" onClick={() => handleClick(item.id_user)} className={`${adminTable.actionBtn} text-zafu-green hover:bg-zafu-cream`} title="Edit">
                                            <FaEdit />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className={adminTable.listEmpty}>
                            {searchTerm ? 'Data tidak ditemukan' : `Data Periode ${periode} tidak ditemukan`}
                        </div>
                    )}
                </div>

                {/* Desktop: tabel */}
                <div className={`${adminTable.card} ${adminTable.desktopOnly}`}>
                    <div className={adminTable.scroll}>
                        <table className={adminTable.table}>
                            <thead className={adminTable.thead}>
                                <tr>
                                    <th className={adminTable.thCenter}>No.</th>
                                    <th className={adminTable.thSortable} onClick={() => handleSort('username')}>
                                        <div className="flex items-center">Username {getSortIcon('username')}</div>
                                    </th>
                                    <th className={adminTable.thSortable} onClick={() => handleSort('nama')}>
                                        <div className="flex items-center">Nama {getSortIcon('nama')}</div>
                                    </th>
                                    <th className={adminTable.thSortable} onClick={() => handleSort('email')}>
                                        <div className="flex items-center">Email {getSortIcon('email')}</div>
                                    </th>
                                    <th className={adminTable.thSortable} onClick={() => handleSort('devisi')}>
                                        <div className="flex items-center">Devisi {getSortIcon('devisi')}</div>
                                    </th>
                                    <th className={adminTable.th}>Lokasi Absensi</th>
                                    <th className={adminTable.thCenter}>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listUsers.length > 0 ? (
                                    listUsers.map((item, index) => (
                                        <tr key={item.id_user} className={adminTable.tr}>
                                            <td className={adminTable.tdCenter}>{(page - 1) * limit + index + 1}</td>
                                            <td className={adminTable.td}>{item.username}</td>
                                            <td className={`${adminTable.td} font-medium`}>{item.nama}</td>
                                            <td className={adminTable.td}>{item.email}</td>
                                            <td className={adminTable.td}>{item.id_devisi?.nama_divisi || '-'}</td>
                                            <td className={adminTable.tdMuted}>{formatLokasiList(item.lokasi_names)}</td>
                                            <td className={adminTable.tdCenter}>
                                                <div className={adminTable.actions}>
                                                    <button type="button" onClick={() => navigate(`/admin/users/detail/${item.id_user}`)} className={`${adminTable.actionBtn} text-zafu-green hover:bg-zafu-cream`} title="Detail">
                                                        <FaCalendarAlt />
                                                    </button>
                                                    <button type="button" onClick={() => navigate(`/admin/users/report/${item.id_user}`)} className={`${adminTable.actionBtn} text-zafu-green-muted hover:bg-zafu-cream`} title="Rekap">
                                                        <FaFileAlt />
                                                    </button>
                                                    <button type="button" onClick={() => handleClick(item.id_user)} className={`${adminTable.actionBtn} text-zafu-green hover:bg-zafu-cream`} title="Edit">
                                                        <FaEdit />
                                                    </button>
                                                    <span className={`${adminTable.actionBtn} text-red-400/80`} title="Hapus">
                                                        <FaTrashAlt />
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7} className={adminTable.empty}>
                                            {searchTerm ? 'Data tidak ditemukan' : `Data Periode ${periode} tidak ditemukan`}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="mt-3">
                    <Pagination
                        currentPage={page}
                        totalPages={meta.totalPages}
                        limitPage={limitPage}
                        selectPage={selectPage}
                        nextPage={nextPage}
                        prevPage={prevPage}
                    />
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Detail Modal"
                ariaHideApp={false}
                className="fixed w-screen inset-0 flex items-center justify-center h-screen p-4 bg-gray-500 bg-opacity-50"
                overlayClassName="fixed z-50 w-screen h-screen inset-0 bg-gray-800 bg-opacity-75"
            >
                <div className=' shadow-lg rounded-lg bg-white md:w-4/5 w-full max-h-[90vh] p-4 overflow-y-auto'>
                    <div className=' text-center pt-2 text-xl font-semibold mb-4'>
                        {modalData && modalData.id_user ? 'EDIT PEGAWAI' : 'TAMBAH PEGAWAI'}
                    </div>
                    <form id='form-Users' className="mt-6" onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label htmlFor="username" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">Username</label>
                                <input
                                    id="username"
                                    type="text"
                                    name="username"
                                    placeholder="Username"
                                    className={`block w-full p-3 mt-2 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner rounded disabled:opacity-50 disabled:cursor-not-allowed ${usernameStatus.available === false ? 'border-2 border-red-500' :
                                            usernameStatus.available === true ? 'border-2 border-green-500' : ''
                                        }`}
                                    required
                                    disabled={modalData && modalData.id_user ? true : false}
                                    defaultValue={modalData?.username || ''}
                                    onChange={(e) => {
                                        if (!modalData || !modalData.id_user) {
                                            debouncedCheckUsername(e.target.value);
                                        }
                                    }}
                                />
                                {modalData && modalData.id_user && (
                                    <p className="text-xs text-gray-500 mt-1">Username tidak dapat diubah</p>
                                )}
                                {!modalData || !modalData.id_user ? (
                                    <div className="mt-1">
                                        {usernameStatus.checking && (
                                            <p className="text-xs text-blue-500">Memeriksa username...</p>
                                        )}
                                        {!usernameStatus.checking && usernameStatus.available === true && (
                                            <p className="text-xs text-green-500">✓ {usernameStatus.message}</p>
                                        )}
                                        {!usernameStatus.checking && usernameStatus.available === false && (
                                            <p className="text-xs text-red-500">✗ {usernameStatus.message}</p>
                                        )}
                                        {!usernameStatus.checking && usernameStatus.available === null && usernameStatus.message && (
                                            <p className="text-xs text-yellow-500">{usernameStatus.message}</p>
                                        )}
                                    </div>
                                ) : null}
                            </div>

                            <div>
                                <label htmlFor="nama" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">Nama</label>
                                <input
                                    id="nama"
                                    type="text"
                                    name="nama"
                                    placeholder="Nama Pegawai"
                                    className="block w-full p-3 mt-2 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner rounded"
                                    required
                                    defaultValue={modalData?.nama || ''}
                                />
                            </div>

                            <div>
                                <label htmlFor="email" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">Email</label>
                                <input
                                    id="email"
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    className="block w-full p-3 mt-2 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner rounded"
                                    required
                                    defaultValue={modalData?.email || ''}
                                />
                            </div>

                            <div>
                                <label htmlFor="password" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">
                                    Password {modalData && modalData.id_user && '(Kosongkan jika tidak ingin mengubah)'}
                                </label>
                                <input
                                    id="password"
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    className="block w-full p-3 mt-2 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner rounded"
                                    required={!modalData || !modalData.id_user}
                                    minLength={6}
                                />
                            </div>

                            <div>
                                <label htmlFor="standard_jam_kerja" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">
                                    Standard Jam Kerja (jam)
                                </label>
                                <input
                                    id="standard_jam_kerja"
                                    type="number"
                                    name="standard_jam_kerja"
                                    placeholder="7"
                                    step="0.5"
                                    min="1"
                                    max="24"
                                    className="block w-full p-3 mt-2 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner rounded"
                                    defaultValue={modalData?.standard_jam_kerja || 7}
                                />
                                <p className="text-xs text-gray-500 mt-1">Default: 7 jam. Kosongkan untuk menggunakan default.</p>
                            </div>

                            <div className="md:col-span-2">
                                <label className="block mt-2 text-xs font-semibold text-gray-600 uppercase">Devisi</label>
                                <select
                                    name='id_devisi'
                                    value={selectedDevisi}
                                    onChange={(e) => setSelectedDevisi(e.target.value)}
                                    className="block w-full p-3 mt-2 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner rounded"
                                    required
                                >
                                    <option value="">Pilih Devisi</option>
                                    {listDevisi?.map((item, index) => (
                                        <option key={index} value={String(item.id_devisi)}>
                                            {item.nama_divisi}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="md:col-span-2">
                                <label className="block mt-2 text-xs font-semibold text-gray-600 uppercase">
                                    Lokasi Absensi (bisa lebih dari satu)
                                </label>
                                <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-1.5">
                                    {listLokasi.length === 0 && (
                                        <p className="col-span-full text-xs text-gray-500">Belum ada lokasi aktif. Buat di menu Data Lokasi.</p>
                                    )}
                                    {listLokasi.map((lokasi) => {
                                        const checked = selectedLokasiIds.includes(Number(lokasi.id_lokasi));
                                        return (
                                            <label
                                                key={lokasi.id_lokasi}
                                                className="flex items-center gap-1.5 text-xs text-gray-700 cursor-pointer min-w-0"
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="shrink-0"
                                                    checked={checked}
                                                    onChange={() => toggleLokasi(lokasi.id_lokasi)}
                                                />
                                                <span className="truncate font-medium" title={lokasi.nama}>{lokasi.nama}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                                {selectedLokasiIds.length > 0 && (
                                    <p className="mt-1.5 text-[11px] text-gray-500">{selectedLokasiIds.length} lokasi dipilih</p>
                                )}
                            </div>
                        </div>

                        <div className="flex gap-4 mt-6">
                            <button
                                type="submit"
                                className="flex-1 py-3 font-medium tracking-widest text-white uppercase bg-[#1B3C33] shadow-lg focus:outline-none hover:bg-[#4a1f20] hover:shadow-none rounded"
                            >
                                Simpan
                            </button>
                            <button
                                type="button"
                                onClick={closeModal}
                                className="flex-1 py-3 font-medium tracking-widest text-white uppercase bg-gray-500 shadow-lg focus:outline-none hover:bg-gray-600 hover:shadow-none rounded"
                            >
                                Batal
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
};

export default Users;